import Axios  from "axios"

export const getMachineries = (machineries) => async (dispatch) => {
    dispatch({
        type: 'MACHINERY_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/machinery/getall/', {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )      
        if(status===200){       
            dispatch({
                type: 'MACHINERIES_GET_SUCCESS',
                payload: data.machineries
            }) 
        }

    } catch (error) {
        dispatch({
            type: 'MACHINERY_ERROR'           
        })         
    }
}

export const getMachineryDetail = (machinery) => async (dispatch) => {
    dispatch({
        type: 'MACHINERY_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/machinery/get/'+ machinery, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )            
        if(status===200){            
            dispatch({
                type: 'MACHINERY_GET_DETAIL_SUCCESS',
                payload: data.machinery
            })             
        }

    } catch (error) {
        dispatch({
            type: 'MACHINERY_ERROR'           
        })         
    }
}

export const addMachinery = (plate, name, description, type, chassis, roma, year, check) => async (dispatch) => {
    dispatch({
        type: 'MACHINERY_LOADING'
    })
    try {
        const {
            data,
            status
        } = await Axios.post(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/machinery/register', {
                plate: plate,
                name: name,
                description: description,
                type: type,
                chassis: chassis,
                roma: roma,
                year: year,
                check: check
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if (status === 200) {
            let newMachinery = {
                _id: data.id,
                plate: plate,
                name: name,
                description: description,
                type: type,
                chassis: chassis,
                roma: roma,
                year: year,
                check: check
            }
            dispatch({
                type: 'MACHINERY_ADD_SUCCESS',
                payload: newMachinery
            })
        }
    } catch (error) {
        dispatch({
            type: 'MACHINERY_FAIL'
        })
    }
}

export const editMachinery = (plate, name, description, type, chassis, roma, year, check, idMachinery) => async (dispatch) => {
    dispatch({
        type: 'MACHINERY_LOADING'
    })
    try {
        await Axios.put(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/machinery/edit/' + idMachinery, {
                plate: plate,
                name: name,
                description: description,
                type: type,
                chassis: chassis,
                roma: roma,
                year: year,
                check: check
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        dispatch({
            type: 'MACHINERY_EDIT_SUCCESS',
            payload: {
                plate: plate,
                name: name,
                description: description,
                type: type,
                chassis: chassis,
                roma: roma,
                year: year,
                check: check,
                _id: idMachinery
            }
        })
    } catch (error) {
        dispatch({
            type: 'MACHINERY_ERROR'
        })
    }
}

export const removeMachinery = (idMachinery) => async (dispatch) => {
    try {
        const {
            data,
            status
        } = await Axios.delete(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/machinery/remove/' + idMachinery, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'MACHINERY_DELETE_SUCCESS',
                payload: {
                    idMachinery: idMachinery,
                    message: data.message,
                    count: data.count
                }
            })
        }else{
            dispatch({
                type: 'MACHINERY_DELETE_NOT_SUCCESS',
                payload: {
                    message: data.message,
                    count: data.count
                }
            })
        }
    } catch (error) {
        dispatch({
            type: 'MACHINERY_ERROR'
        })
    }
}